import { isValidYamsUrl } from './yams/isValidYamsUrl';
import { FALLBACK_SIZE, FALLBACK_FORMAT } from './constants';
import { isValidEpsUrl } from './eps/isValidEpsUrl';
import { getEpsImageUrl } from './eps/getEpsImageUrl';
import { getYamsImageUrl } from './yams/getYamsImageUrl';
import { isValidCloudinaryUrl } from './cloudinary/isValidCloudinaryUrl';
import { getCloudinaryImageUrl } from './cloudinary/getCloudinaryImageUrl';
const ensureProtocol = (url, protocol) => url.replace(/^([a-z]*:\/\/)?(.*)/, `${protocol}://$2`);
/**
 * Convert a URL to either EPS or YAMS image URL format.
 * @param url - URL to convert
 * @param options - Object containing conversion options (size, format, transformation, protocol)
 * @returns Valid image URL or input URL in case it cannot be converted
 */
export const getImageUrl = (url, { size = FALLBACK_SIZE, format = FALLBACK_FORMAT, transformation, protocol = 'https' } = {}) => {
    let parsedUrl;
    try {
        parsedUrl = new URL(ensureProtocol(url || '', protocol));
    }
    catch (_) {
        return url;
    }
    if (isValidCloudinaryUrl(url)) {
        return getCloudinaryImageUrl(url || '', size);
    }
    if (isValidYamsUrl(parsedUrl)) {
        return getYamsImageUrl(parsedUrl, size, format, transformation);
    }
    if (isValidEpsUrl(parsedUrl, size)) {
        return getEpsImageUrl(parsedUrl, { size, format });
    }
    return url;
};
